/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PlayListDto } from '../../models/play-list-dto';
import { UpdatePlaylistDto } from '../../models/update-playlist-dto';

export interface PlaylistControllerUpdate$Params {
  playListId: string;
  clientWorkspaceId: string;
      body: UpdatePlaylistDto
}

export function playlistControllerUpdate(http: HttpClient, rootUrl: string, params: PlaylistControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<PlayListDto>> {
  const rb = new RequestBuilder(rootUrl, playlistControllerUpdate.PATH, 'patch');
  if (params) {
    rb.path('playListId', params.playListId, {});
    rb.path('clientWorkspaceId', params.clientWorkspaceId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PlayListDto>;
    })
  );
}

playlistControllerUpdate.PATH = '/api/playlist/{clientWorkspaceId}/{playListId}';
